import { useState, useEffect } from 'react';
import config from '../config';

function convertForecastMetersToFeet(data) {
  if (Array.isArray(data)) {
    return data.map((entry) => {
      entry['stage'] = config.convertMetersToFeet(entry.stage_masl);
      entry['flow'] = config.convertCMStoCFS(entry.flow_cms);
      return entry;
    });
  }
  return [];
}

async function makeRequest(url) {
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

async function requestForecast(
  stateSchema,
  locationIDs,
  forecastType,
  forecastPubTime
) {
  if (locationIDs) {
    const assetID = locationIDs.asset_id;
    let fetchURL = `${config.forecastURL}/${stateSchema}/${assetID}/${forecastType}`;
    if (forecastPubTime) {
      fetchURL += `/${config.getPGPubtimeStrUTC(forecastPubTime)}`;
    }
    const data = await makeRequest(fetchURL);
    return convertForecastMetersToFeet(data);
  }
  return;
}

export default function useForecast({
  stateSchema,
  locationIDs,
  forecastPubTime
}) {
  const [forecastShort, setForecastShort] = useState();
  const [forecastMedium, setForecastMedium] = useState();

  useEffect(() => {
    setForecastShort(undefined);
    if (stateSchema && locationIDs) {
      requestForecast(stateSchema, locationIDs, 'short', forecastPubTime)
        .then((data) => {
          setForecastShort(data);
        })
        .catch((error) => {
          console.error('Error fetching short forecast: ' + error);
        });
    }
  }, [stateSchema, locationIDs, forecastPubTime]);

  useEffect(() => {
    setForecastMedium(undefined);
    if (stateSchema && locationIDs) {
      requestForecast(stateSchema, locationIDs, 'medium', forecastPubTime)
        .then((data) => {
          setForecastMedium(data);
        })
        .catch((error) => {
          console.error('Error fetching medium forecast: ' + error);
        });
    }
  }, [stateSchema, locationIDs, forecastPubTime]);

  return { forecastShort, forecastMedium };
}
